import { Component, ChangeDetectionStrategy, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { PopoverDirective } from 'ngx-bootstrap/popover';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LocalStorageService } from '../../../../../gamma/localstorage';
import { RoutingService } from '../../../../../gamma/routing';
import { SecurityService } from '../../../../../gamma/security';

import { IU2000_Application, U2000_ApplicationMenuService } from '../../../../U2000_core/U2000_services/U2000_applicationmenu.service';
import { U2000_AuthenticationService } from '../../../../U2000_core/U2000_services/U2000_authentication.service';

@Component({
    selector: '[u2000-applicationsmenu]',
    templateUrl: 'U2000_applicationsmenu.component.html',
    styleUrls: ['U2000_applicationsmenu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2000_ApplicationsMenuComponent implements OnInit, OnDestroy {
    popover: PopoverDirective;

    applications: IU2000_Application[];

    // Browser back/forward navigation does not trigger the popover's (clickOutside) handler
    // (no click event is fired), so the menu is closed explicitly on every navigation instead.
    private navigationSubscription: Subscription;

    constructor(
        public authService: U2000_AuthenticationService,
        public routingService: RoutingService,
        private securityService: SecurityService,
        private localStorageService: LocalStorageService,
        public applicationMenuService: U2000_ApplicationMenuService,
        private router: Router,
    ) {
        this.applications = this.applicationMenuService.applications;
    }

    ngOnInit() {
        this.navigationSubscription = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
            this.onClickOutside();
        });
    }

    ngOnDestroy() {
        this.navigationSubscription?.unsubscribe();
    }

    showMenu(popover: PopoverDirective) {
        this.popover = popover;
        if (this.popover) {
            if (this.popover.isOpen()) {
                this.popover.hide();
            } else {
                this.popover.show();
            }
        }
    }

    onClickOutside() {
        if (this.popover && this.popover.isOpen()) {
            this.popover.hide();
        }
    }

    applicationVisible(application: IU2000_Application) {
        if (application.securityFn) {
            return application.securityFn(application);
        } else if (application.securityTags != null) {
            return this.securityService.hasAccess(application.securityTags);
        }
        return true;
    }

    getRouterLink(application: IU2000_Application) {
        let route: string | string[] = this.localStorageService.get(this.applicationMenuService.getLocalStorageName(application.module));

        if (!this.applicationMenuService.haveAccessToRoute(route, application.options) || route == null) {
            if (application.routeFn) {
                route = application.routeFn(application);
            } else {
                route = application.route;
            }
        }
        return route;
    }
}
